import * as AseguradoRepository from "../../services/repositories/asegurado-repository";
import * as Constantes from '../../utils/constantes'
import * as CuestionarioRepository from "../../services/repositories/cuestionario-repository";
import * as FamiliarRepository from "../../services/repositories/familiar-repository";
import * as Funciones from '../../utils/funciones'
import * as GeneralActions from '../../store/actions/generalActions'
import * as ProductoRepository from "../../services/repositories/producto-repository";
import * as SolicitudRepository from "../../services/repositories/solicitud-repository";

import React, { Suspense, lazy, useContext, useEffect, useRef, useState } from 'react'

import CampoFecha from '../../components/CampoFecha/CampoFecha'
import CargandoPagina from '../../components/CargandoPagina'
import Footer from '../../components/Footer'
import GeneralContext from '../../context/GeneralContext'
import Header from '../../components/Header'
import Modal from '../../components/Modals'
import SubMenu from '../../components/SubMenu'
import Subtitle from '../../components/Subtitle'
import styles from './DeclaracionSalud.module.css'

//Utiles



//Context


//Actions










const QuestionnaireLazy = lazy(
	() =>
	  import("./components/ListQuestionnaire/ListQuestionnaire")
  );

const DeclaracionSalud = ({ history }) => {
	
	const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
	let user = generalState.users.filter(user => user.isAuthenticated)[0]
	let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
	let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

	const insuredPrincipalTab = 1;
	const insureAditionalTab = 2;

	const [tap, setTap] = useState(insuredPrincipalTab);
	const [answersPrincipalComplete, setAnswersPrincipalComplete] = useState(false);
	const [answersAditionalComplete, setanswersAditionalComplete] = useState(false);

	const initialState = {
		estaCargando: true,
		estaCargandoFamily: true,
		errorCargando: null,
		asegurado: null,
		aseguradoAdicional: null,
		productos: null,
		reloadValidacion: false,
		assessmentIdSolicitudes: null,
		assessmentIdSolicitudesAdicional: null,
		campoValidado: {
			nombres: true,
			apellidoPaterno: true,
			apellidoMaterno: true,
			tipoDocumento: true,
			numeroDocumento: true,
			fechaNacimiento: true,
			nacionalidad: true,
			estadoCivil: true,
		},
		campoValidadoAdicional: {
			nombres: true,
			apellidoPaterno: true,
			apellidoMaterno: true,
			tipoDocumento: true,
			numeroDocumento: true,
			fechaNacimiento: true,
			nacionalidad: true,
			estadoCivil: true,
		},
		suscripcion: null,
		isOpenQuestionnaireSubscription: false,
		isOpenQuestionnaireSubscriptionAditional: false,
		suscripcionAdicional: null,
		suscripcionResultado: false,
		suscripcionResultadoAdicional: false,
		cuestionarioValidado: false,
		cuestionarioValidadoAdicional: false,
		esAPFamiliar: null,
		conyuge: null,
		hijos: null,
		fumador: null,
		fumadorAdicional: null,
		confProducto: null,
		bloqueaFecha: false,
		esAseguradoAdicional: false
	}

	//[INI]-Se agrega mensaje para la validación del botón 'Finalizar DS'
	const textos = [
		'Suscripción Inteligente',
		'Completa el cuestionario y pulsa "Siguiente/Aceptar"',
	]
	//[FIN]-Se agrega mensaje para la validación del botón 'Finalizar DS'

	const textos2 = [
		'Declaración Salud',
		'Debes pulsar el botón "Finalizar DS" para continuar'
	]
  
	const textos3 = [
		'Declaración Salud',
		'Debes iniciar y completar el formulario de Declaración de Salud para continuar'
	]

	const textos6 = [
		'Declaración Salud',
		'Debes iniciar y completar el formulario de Declaración de Salud del Asegurado Adicional para continuar'
	]
  
	const textos4 = ['Declaración Salud', 'Ud. ya tiene una Declaración de Salud previamente registrada, ¿Desea llenarla nuevamente?']
	const [textos5, setTextos5] = useState([])

	const [mostrarModal, setModal] = useState(false)
	const [mostrarModal2, setModal2] = useState(false)
	const [mostrarModal3, setModal3] = useState(false)
	const [mostrarModal4, setModal4] = useState(false)
	const [mostrarModalCuestionario, setMostrarModalCuestionario] = useState(false);
	const [mostrarModal4Adicional, setModal4Adicional] = useState(false)
	const [mostralModal5, setModal5] = useState(false)
	const [mostrarModal6, setModal6] = useState(false)
	const [state, setState] = useState(initialState)
	const [documentos, setDocumentos] = useState([])
	const [estados, setEstados] = useState([])
	const [nacionalidades, setNacionalidades] = useState([])
	const [ocultaBoton, setOcultaBoton] = useState(false)     //Estado para ocultar el boton de 'Iniciar DS'
	const [ocultaAdicionalBoton, setOcultaAdicionalBoton] = useState(false)
	const [modalWeightHeight, setModalWeightHeight] = useState(false)
	const textWeightHeightRef = useRef([])

	const nombresRef = useRef()
	const apePaternoRef = useRef()
	const apeMaternoRef = useRef()
	const nroDocRef = useRef()

	useEffect(() => {
		setState({...state,isOpenQuestionnaireSubscription: false, isOpenQuestionnaireSubscriptionAditional: false});
		const cargarCombos = () => {
			setDocumentos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 13))
			setEstados(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 14))
			setNacionalidades(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 40))
		}

		cargarCombos();
		cargarDatosIniciales();
		return () => { deleteScriptQuestionnaire(); };
	}, [])

	const cargarDatosIniciales = async () => {
		generalDispatch(GeneralActions.updateEstadoCargando(true))
		await flagEsAseguradoAdicional()
		await obtenerProductoConfiguracion()
		generalDispatch(GeneralActions.updateEstadoCargando(false))
	}

	const flagEsAseguradoAdicional = async () => {
        let esAseguradoAdicional = false
        cotizacion.solicitudes.map(solicitud => {
            esAseguradoAdicional = solicitud.indicadorAseguradoAdicional
        })
        setState((state) => {
            return {
                ...state,
                esAseguradoAdicional: esAseguradoAdicional
            }
        })
    }

	const obtenerProductoConfiguracion = async () => {
		let shouldShowDS = false
		let shouldHideButton = false
		
		for (const prod of cotizacion.productos) {
			const response = await ProductoRepository.obtenerConfiguracionProducto(prod.codigoProducto, prod.codigoVersionProducto)
			
			// Guard clause: validar error primero
			if(response.error) {
				generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
				continue
			}
			
			// Guard clause: validar que existe configuracion antes de acceder a sus propiedades
			if(!response.configuracion) {
				continue
			}
			
			const flagIsCuestionarioVic = response.configuracion.flagIsCuestionarioVic
			const isSpecialProduct = Constantes.SPECIAL_PRODUCT_CODES.includes(prod.codigoProducto)
			
			shouldShowDS = Boolean(flagIsCuestionarioVic)
			shouldHideButton = isSpecialProduct
			
			if (isSpecialProduct) {
				break
			}
			
			if (!flagIsCuestionarioVic) {
				continue
			}
		}
		
		// Si tiene producto especial con flagIsCuestionarioVic true, ocultar el botón
		// Si no, mostrar/ocultar según flagIsCuestionarioVic
		setOcultaBoton(shouldHideButton || !shouldShowDS)
		setState((state) => {
			return {
				...state,
				estaCargandoFamily: false,
				errorCargando: null,
				confProducto: shouldShowDS
			}
		})
		await obtenerSolicitudes()
	}

	const obtenerSolicitudes = async () => {
		const response = await SolicitudRepository.obtenerSolicitudes(cotizacion.idSolicitudMultiple)
		if(response.error === null) {
			setState((state) => {
				return {
					...state,
					assessmentIdSolicitudes: response.solicitudes.asegurado !== undefined && response.solicitudes.asegurado !== null ? response.solicitudes.asegurado.assessmentId : null,
					productos: response.solicitudes.productos,
					fumador: response.solicitudes.asegurado?.condicionFumador,
					suscripcionResultado: response.solicitudes.asegurado.assessmentId !== null ? true : false
				}
			})
			generalDispatch(GeneralActions.setContratanteCotizacion(response.solicitudes.contratante !== null ? response.solicitudes.contratante.idSolicitudMultiple === 0 ? undefined : response.solicitudes.contratante : undefined))
			await obtenerAsegurado()
		} else {
			generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
		}
	}

	const obtenerAsegurado = async () => {
		if (cotizacion.asegurado !== null && cotizacion.asegurado !== undefined) {
			setState((state) => {
				return {
					...state,
					estaCargando: false,
					errorCargando: null,
					asegurado: {
						...cotizacion.asegurado,
						nacionalidad: {
							codigo: cotizacion.asegurado.tipoDocumento.codigo !== 1 && cotizacion.asegurado.nacionalidad.codigo !== 1
								? cotizacion.asegurado.nacionalidad.codigo
								: cotizacion.asegurado.tipoDocumento.codigo === 1 || cotizacion.asegurado.tipoDocumento.codigo === 2
								? 1 : cotizacion.asegurado.nacionalidad.codigo
						}
					},
					esAPFamiliar: cotizacion.esAPFamiliar,
					bloqueaFecha: cotizacion.asegurado.fechaNacimiento !== null ? true : false
				}
			})
			await obtenerFamiliares()
		} else {
			const response = await AseguradoRepository.obtenerAsegurado(cotizacion.idSolicitudMultiple)
			if(response.error === null) {
				let aseguradoTemporal = response.asegurado
				setState((state) => {
					return {
						...state,
						errorCargando: null,
						asegurado: {
							...aseguradoTemporal,
							nacionalidad: {
								codigo: aseguradoTemporal.tipoDocumento.codigo !== 1 && aseguradoTemporal.nacionalidad.codigo !== 1
								? aseguradoTemporal.nacionalidad.codigo
								: aseguradoTemporal.tipoDocumento.codigo === 1 || aseguradoTemporal.tipoDocumento.codigo === 2 ? 1 : ''
							}
						},
						esAPFamiliar: cotizacion.esAPFamiliar,
						bloqueaFecha: response.asegurado.fechaNacimiento !== null ? true : false
					}
				})
				await obtenerFamiliares()
			} else {
				generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
			}
		}
	}

	const obtenerFamiliares = async () => {
		const response = await FamiliarRepository.obtenerFamiliares(cotizacion.idSolicitudMultiple)
		if(response.error === null) {
			// Familiares
			let conyuge = response.familiares.filter((item) => item.parentesco.codigo === 1)[0]
			let hijos = response.familiares.filter((item) => item.parentesco.codigo === 2 || item.parentesco.codigo === 3)
			let arregloHijosFormatted = hijos !== undefined && hijos !== null ? hijos.map(hijo => formatDate(hijo.fechaNacimiento)) : {}
			//let aseguradoAdicional = response.familiares[0]
			//console.log(response.familiares.filter((item) => item.indicadorAseguradoAdicional === 1))
			let aseguradoAdicional = await response.familiares.filter((item) => item.indicadorAseguradoAdicional === 1)[0]

			if (conyuge === undefined) {
				conyuge = {}
			}

			let esAseguradoAdicionalAux = false
			cotizacion.solicitudes.map(solicitud => {
				esAseguradoAdicionalAux = solicitud.indicadorAseguradoAdicional
			})

			setState((state) => {
				return {
					...state,
					estaCargandoFamily: false,
					errorCargando: null,
					conyuge: conyuge,
					hijos: arregloHijosFormatted,
					aseguradoAdicional: aseguradoAdicional,
					assessmentIdSolicitudesAdicional: aseguradoAdicional !== undefined && aseguradoAdicional !== null ? aseguradoAdicional?.assessmentIdAseguradoAdicional : null,
					fumadorAdicional: esAseguradoAdicionalAux ? aseguradoAdicional?.condicionFumador : null,
					suscripcionResultadoAdicional: esAseguradoAdicionalAux && aseguradoAdicional?.assessmentIdAseguradoAdicional !== null ? true : false
				}
			})

			if(esAseguradoAdicionalAux){
				await obtenerFamiliaresAdjuntos(aseguradoAdicional?.idFamiliar)
			} else {
				setState((state) => {
					return {
						...state,
						aseguradoAdicional: {
							...state.aseguradoAdicional,
							adjuntos: []
						}
					}
				})
			}
			
		} else {
			generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
		}
	}

	const obtenerFamiliaresAdjuntos = async (idFamiliar) => {
		const response = await FamiliarRepository.obtenerFamiliaresAdjuntosTipo(cotizacion.idSolicitudMultiple, idFamiliar, 3)
		if(response.error === null) {
			setState((state) => {
				return {
					...state,
					aseguradoAdicional: {
						...state.aseguradoAdicional,
						adjuntos: response.familiares,
						usuario: user.info.IdUsuario
					}
				}
			})
		}
	}

	const handleChangeTipDocumento = (event) => {
		let codigo = event.target.value
		let descripcion = event.target[event.target.selectedIndex].text
		setState((state) => {
			let codigoNacionalidad = null
			if (descripcion.toUpperCase().indexOf(Constantes.DESC_TIPO_DOCUMENTO_DNI) > -1) {
				codigoNacionalidad = Constantes.COD_NACIONALIDAD_PERUANA
			} else {
				codigoNacionalidad = null
			}
			return {
				...state,
				asegurado: {
					...state.asegurado,
					tipoDocumento: {
						codigo: parseInt(codigo),
						descripcion: descripcion,
					},
					nacionalidad: {
						...state.asegurado.nacionalidad,
						codigo: codigoNacionalidad,
					}
				}
			}
		})
	}

	const handleChangeTipDocumentoAdicional = (event) => {
		let codigo = event.target.value
		let descripcion = event.target[event.target.selectedIndex].text
		setState((state) => {
			let codigoNacionalidad = null
			if (descripcion.toUpperCase().indexOf(Constantes.DESC_TIPO_DOCUMENTO_DNI) > -1) {
				codigoNacionalidad = Constantes.COD_NACIONALIDAD_PERUANA
			} else {
				codigoNacionalidad = null
			}
			return {
				...state,
				aseguradoAdicional: {
					...state.aseguradoAdicional,
					tipoDocumento: {
						codigo: parseInt(codigo),
						descripcion: descripcion,
					},
					nacionalidad: {
						...state.aseguradoAdicional.nacionalidad,
						codigo: codigoNacionalidad,
					}
				}
			}
		})
	}

	const handleChangeNacionalidad = (event) => {
		let codigo = event.target.value
		let descripcion = event.target[event.target.selectedIndex].text
		setState((state) => {
			return {
				...state,
				asegurado: {
					...state.asegurado,
					nacionalidad: {
						codigo: parseInt(codigo),
						descripcion: descripcion,
					},
					campoValidado: {
						...state.campoValidado,
						nacionalidad: true
					}
				}
			}
		})
	}

	const handleChangeNacionalidadAdicional = (event) => {
		let codigo = event.target.value
		let descripcion = event.target[event.target.selectedIndex].text
		setState((state) => {
			return {
				...state,
				aseguradoAdicional: {
					...state.aseguradoAdicional,
					nacionalidad: {
						codigo: parseInt(codigo),
						descripcion: descripcion,
					}
				},
				campoValidadoAdicional: {
					...state.campoValidadoAdicional,
					nacionalidad: true
				}
			}
		})
	}

	const handleChangeSexo = (event) => {
		const sexoVal = event.target.value
		setState((state) => {
			return {
				...state,
				asegurado: {
					...state.asegurado,
					sexo: {
						...state.asegurado.sexo,
						codigo: parseInt(sexoVal),
					}
				}
			}
		})
	}

	const handleChangeSexoAdicional = (event) => {
		const sexoVal = event.target.value
		setState((state) => {
			return {
				...state,
				aseguradoAdicional: {
					...state.aseguradoAdicional,
					sexo: {
						...state.aseguradoAdicional.sexo,
						codigo: parseInt(sexoVal),
					}
				}
			}
		})
	}

	const handleChangeEstadoCivil = (event) => {
		let codigo = event.target.value
		let descripcion = event.target[event.target.selectedIndex].text
		setState((state) => {
			return {
				...state,
				asegurado: {
					...state.asegurado,
					estadoCivil: {
						codigo: parseInt(codigo),
						descripcion: descripcion
					}
				},
				campoValidado: {
					...state.campoValidado,
					estadoCivil: true
				}
			}
		})
	}

	const handleChangeEstadoCivilAdicional = (event) => {
		let codigo = event.target.value
		let descripcion = event.target[event.target.selectedIndex].text
		setState((state) => {
			return {
				...state,
				aseguradoAdicional: {
					...state.aseguradoAdicional,
					estadoCivil: {
						codigo: parseInt(codigo),
						descripcion: descripcion
					}
				},
				campoValidadoAdicional: {
					...state.campoValidadoAdicional,
					estadoCivil: true
				}
			}
		})
	}

	const handleChangeTexto = (event, campo) => {
		let valor = event.target.value.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, '')
		setState((state) => {
			return {
				...state,
				asegurado: {
					...state.asegurado,
					[campo]: valor,
					indicadorModificacionDatosPID: '2'
				},
				campoValidado: {
					...state.campoValidado,
					[campo]: true
				}
			}
		})
	}

	const handleChangeTextoAdicional = (event, campo) => {
		let valor = event.target.value.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, '')
		setState((state) => {
			return {
				...state,
				aseguradoAdicional: {
					...state.aseguradoAdicional,
					[campo]: valor,
					indicadorModificacionDatosPID: '2'
				},
				campoValidadoAdicional: {
					...state.campoValidadoAdicional,
					[campo]: true
				}
			}
		})
	}

	const handleChangeNumerico = (event, campo) => {
		let valor = event.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, '')
		setState((state) => {
			return {
				...state,
				asegurado: {
					...state.asegurado,
					[campo]: valor
				}
			}
		})
	}

	const handleChangeNumericoAdicional = (event, campo) => {
		let valor = event.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, '')
		setState((state) => {
			return {
				...state,
				aseguradoAdicional: {
					...state.aseguradoAdicional,
					[campo]: valor
				}
			}
		})
	}

	const handleChangeFecha = (event, campo) => {
		let valor = event
		setState((state) => {
			return {
				...state,
				asegurado: {
					...state.asegurado,
					[campo]: Funciones.transformarDatePickerToFecha(valor)
				}
			}
		})
	}

	const handleChangeFechaAdicional = (event, campo) => {
		let valor = event
		setState((state) => {
			return {
				...state,
				aseguradoAdicional: {
					...state.aseguradoAdicional,
					[campo]: Funciones.transformarDatePickerToFecha(valor)
				}
			}
		})
	}

	const formatDate = (date) => {
		var d = new Date(date),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear()

		if (month.length < 2) month = '0' + month
		if (day.length < 2) day = '0' + day

		return [year, month, day].join('-')
	}

	const mostrarSuscripcionAdicional = async () => {
		if ((state.aseguradoAdicional.tipoDocumento === null && state.aseguradoAdicional.tipoDocumento === undefined) ||
			(state.aseguradoAdicional.numeroDocumento === null && state.aseguradoAdicional.numeroDocumento === '')) {
				setModal5(true)
				setTextos5(['¡Importante!', 'Para iniciar el formulario de declaración de salud, deberá completar el tipo de documento y/o número de documento en Agenda.'])
		} else if (state.aseguradoAdicional.fechaNacimiento === null) {
			setModal5(true)
			setTextos5(['¡Importante!', 'Para iniciar el formulario de declaración de salud, debe completar la fecha de nacimiento.'])
		} else {
			if (existeAssessmetIdAdicional !== undefined || existeAssessmetIdAdicional !== null) {
				generalDispatch(GeneralActions.updateEstadoCargando(true))
				let productos = state.productos.map((item) => ({
					codigoProducto: item.codigoProducto,
					codigoVersionProducto: item.codigoVersionProducto,
					cobertura: item.coberturas.map((itemCobertura) => ({
						codigoCobertura: itemCobertura.codigo,
						condicionCoberturaPrincipal: itemCobertura.esCoberturaPrincipal,
						duracionPoliza: item.periodoCobertura > 0 ? item.periodoCobertura * 12 : 120,
						sumaAsegurada: parseFloat(itemCobertura.monto)
					}))
				}))
				
				const response = await CuestionarioRepository.iniciarCuestionario(state.aseguradoAdicional, productos, false, {}, {}, state.fumadorAdicional)
				if(response.error === null) {
					setState((state) => {
						return {
							...state,
							suscripcionAdicional: response.cuestionario,
							cuestionarioValidadoAdicional: false,
							isOpenQuestionnaireSubscriptionAditional: true
						}
					})
					setOcultaAdicionalBoton(true)
					generalDispatch(GeneralActions.updateEstadoCargando(false))
					return true
				} else {
					generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
					generalDispatch(GeneralActions.updateEstadoCargando(false))
					return false
				}
			} else {
				mostrarPopup4Adicional()
			}
		}
	}

	const mostrarSuscripcion = async () => {
		if ((state.asegurado.tipoDocumento === null && state.asegurado.tipoDocumento === undefined) ||
			(state.asegurado.numeroDocumento === null && state.asegurado.numeroDocumento === '')) {
				setModal5(true)
				setTextos5(['¡Importante!', 'Para iniciar el formulario de declaración de salud, deberá completar el tipo de documento y/o número de documento en Agenda.'])
		} else if (state.asegurado.fechaNacimiento === null) {
			setModal5(true)
			setTextos5(['¡Importante!', 'Para iniciar el formulario de declaración de salud, debe completar la fecha de nacimiento.'])
		} else {
			if (existeAssessmetId !== undefined || existeAssessmetId !== null) {
				generalDispatch(GeneralActions.updateEstadoCargando(true))
				let productos = state.productos.map((item) => ({
					codigoProducto: item.codigoProducto,
					codigoVersionProducto: item.codigoVersionProducto,
					cobertura: item.coberturas.map((itemCobertura) => ({
						codigoCobertura: itemCobertura.codigo,
						condicionCoberturaPrincipal: itemCobertura.esCoberturaPrincipal,
						duracionPoliza: item.periodoCobertura > 0 ? item.periodoCobertura * 12 : 120,
						sumaAsegurada: parseFloat(itemCobertura.monto)
					}))
				}))

				const response = await CuestionarioRepository.iniciarCuestionario(state.asegurado, productos, state.esAPFamiliar, state.conyuge, state.hijos, state.fumador)
				if(response.error === null) {
					setState((state) => {
						return {
							...state,
							suscripcion: response.cuestionario,
							cuestionarioValidado: false,
							isOpenQuestionnaireSubscription: true
						}
					})
					setOcultaBoton(true)
					generalDispatch(GeneralActions.updateEstadoCargando(false))
					return true
				} else {
					generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
					generalDispatch(GeneralActions.updateEstadoCargando(false))
					return false
				}
			} else {
				mostrarPopup4()
			}
		}
	}

	const finalizarSD = async () => {
		if(!answersPrincipalComplete){
			return false;
		}
		generalDispatch(GeneralActions.updateEstadoCargando(true))
		let productos = state.productos.map((item) => ({
			codigoProducto: item.codigoProducto,
			codigoVersionProducto: item.codigoVersionProducto,
			cobertura: item.coberturas.map((itemCobertura) => ({
				codigoCobertura: itemCobertura.codigo,
				condicionCoberturaPrincipal: itemCobertura.esCoberturaPrincipal,
				// DuracionPoliza: item.periodoCobertura > 0 ? item.periodoCobertura : 120,
				duracionPoliza: item.periodoCobertura > 0 ? item.periodoCobertura * 12 : 120,
				sumaAsegurada: parseFloat(itemCobertura.monto),
			})),
		}))

		const response = await CuestionarioRepository.obtenerResultadoCuestionario(state.suscripcion.assessmentId, productos)
		if(response.error === null) {
			setState((state) => {
				return {
					...state,
					suscripcionResultado: response.resultado,
					
				}
			})
			generalDispatch(GeneralActions.updateEstadoCargando(false))
			return true
		} else {
			generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
			generalDispatch(GeneralActions.updateEstadoCargando(false))
			return false
		}
	}

	const finalizarSDAdicional = async () => {
		if(!answersAditionalComplete){
			return false;
		}
		generalDispatch(GeneralActions.updateEstadoCargando(true))
		let productos = state.productos.map((item) => ({
			codigoProducto: item.codigoProducto,
			codigoVersionProducto: item.codigoVersionProducto,
			cobertura: item.coberturas.map((itemCobertura) => ({
				codigoCobertura: itemCobertura.codigo,
				condicionCoberturaPrincipal: itemCobertura.esCoberturaPrincipal,
				// DuracionPoliza: item.periodoCobertura > 0 ? item.periodoCobertura : 120,
				duracionPoliza: item.periodoCobertura > 0 ? item.periodoCobertura * 12 : 120,
				sumaAsegurada: parseFloat(itemCobertura.monto),
			})),
		}))

		const response = await CuestionarioRepository.obtenerResultadoCuestionario(state.suscripcionAdicional.assessmentId, productos)
		if(response.error === null) {
			setState((state) => {
				return {
					...state,
					suscripcionResultadoAdicional: response.resultado
				}
			})
			generalDispatch(GeneralActions.updateEstadoCargando(false))
			return true
		} else {
			generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
			generalDispatch(GeneralActions.updateEstadoCargando(false))
			return false
		}
	}

	const terminoSD = async () => {
		if (await finalizarSD()) {
			setState((state) => {
				return {
					...state,
					cuestionarioValidado: true,
					isOpenQuestionnaireSubscription: false
				}
			})
		} else {
			mostrarPopup()
		}
	}

	const terminoSDAdicional = async () => {
		if (await finalizarSDAdicional()) {
			setState((state) => {
				return {
					...state,
					cuestionarioValidadoAdicional: true,
					isOpenQuestionnaireSubscriptionAditional: false
				}
			})
		} else {
			mostrarPopup()
		}
	}

	const mostrarPopup = () => {
		setModal(!mostrarModal)
	}

	const mostrarPopup2 = () => {
		setModal2(!mostrarModal2)
	}

	const mostrarPopup3 = () => {
		setModal3(!mostrarModal3)
	}

	const mostrarPopup6 = () => {
		setModal6(!mostrarModal6)
		setTap(2)
	}

	const mostrarPopup4 = () => {
		setModal4(!mostrarModal4)
	}

	const mostrarPopup4Adicional = () => {
		setModal4Adicional(!mostrarModal4Adicional)
	}

	const invocarPostAseguradoAdicionalDeclaracionSalud = async () => {
		let devuelve = false
		let assessment = state.suscripcionAdicional !== null ? state.suscripcionAdicional.assessmentId : null
		let idSolicitudMultiple = state.asegurado !== undefined && state.asegurado !== null ? state.asegurado.idSolicitudMultiple : null;
		let usuario = user !== undefined ? user.info.IdUsuario : null;

		let coberturas = []
		if(state.suscripcionResultadoAdicional.producto !== undefined && state.suscripcionResultadoAdicional.producto !== null) {
			state.suscripcionResultadoAdicional.producto.map((item) =>
				item.cobertura.map((item2) => {
					coberturas.push({
						codigoProducto: item.codigoProducto,
						codigoVersionProducto: item.codigoVersionProducto,
						codigoCobertura: item2.codigoCobertura,
						respuestaReflex: item2.flagRespuesta
					})
					return item2
				})
			)
		}

		if (coberturas.length > 0) {
			let cuestionario = {
				assessmentId: assessment,
				coberturas: coberturas,
				usuario: usuario,
			}
			const response = await FamiliarRepository.guardarFamiliarAdicionalDeclaracion(idSolicitudMultiple, cuestionario)
			if(response.error === null) {
				setState((state) => {
					return {
						...state,
						estaCargando: false,
						pasarServicioPost: true,
						errorCargando: null
					}
				})
				devuelve = true
			} else {
				generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
			}

			generalDispatch(GeneralActions.setAseguradoAdicionalProspecto({...state.aseguradoAdicional}))
		}

		return devuelve
	}

	//se extrajo esta funcion fuera de la funcion de validarFormulario()
	const invocarPostAseguradoDeclaracionSalud = async () => {
		let devuelve = false
		let assessment = state.suscripcion !== null ? state.suscripcion.assessmentId : null
		let idSolicitudMultiple = state.asegurado !== undefined && state.asegurado !== null ? state.asegurado.idSolicitudMultiple : null;
		let usuario = user !== undefined ? user.info.IdUsuario : null;

		let coberturas = []
		if(state.suscripcionResultado.producto !== undefined && state.suscripcionResultado.producto !== null) {
			state.suscripcionResultado.producto.map((item) =>
				item.cobertura.map((item2) => {
					coberturas.push({
						codigoProducto: item.codigoProducto,
						codigoVersionProducto: item.codigoVersionProducto,
						codigoCobertura: item2.codigoCobertura,
						respuestaReflex: item2.flagRespuesta
					})
					return item2
				})
			)
		}

		//se valida si existen coberturas
		if (coberturas.length > 0) {
			let cuestionario = {
				assessmentId: assessment,
				coberturas: coberturas,
				usuario: usuario,
			}
			const response = await CuestionarioRepository.guardarCuestionario(idSolicitudMultiple, cuestionario)
		if(response.error === null) {
			if(response.resultado.code === 200) {
				setState((state) => {
					return {
						...state,
						estaCargando: false,
						pasarServicioPost: true,
						errorCargando: null
					}
				})
				devuelve = true
			} else {
				textWeightHeightRef.current = ["Declaracion", response.resultado.data + " Refresca la página y vuelve a llenar la Declaración de Salud"]
			}
		} else {
			generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
		}

			generalDispatch(GeneralActions.setAseguradoProspecto(
				{
					...state.asegurado,
					indicadorModificacionDatosPID: state.asegurado.indicadorModificacionDatosPID === '2' ? state.asegurado.indicadorModificacionDatosPID : '1'
				}
			))
		}

		return devuelve
	}

	const validarFormulario = async () => {
		let validado = true
		
		// Verificar si algún producto tiene código 176, 177 o 178
		const hasSpecialProduct = cotizacion.productos && cotizacion.productos.some(prod => 
			Constantes.SPECIAL_PRODUCT_CODES.includes(prod.codigoProducto)
		)
		
		const asignarValidacionCampo = (campo, valor) => {
			validado = validado && valor
			setState((state) => {
				return {
					...state,
					campoValidado: {
						...state.campoValidado,
						[campo]: valor
					}
				}
			})
		}

		const validarTexto = (objeto, campoValidacion, campo) => {
			if (objeto === null || objeto[campo] === undefined ||
				objeto[campo] === null || objeto[campo] === '') {
					asignarValidacionCampo(campoValidacion, false)
			} else {
				asignarValidacionCampo(campoValidacion, true)
			}
		}

		const validarCombo = (objeto, campoValidacion, campo) => {
			if (objeto === null || objeto[campo] === null ||
				objeto[campo] === undefined ||
				objeto[campo].codigo === null ||
				objeto[campo].codigo === -1 ||
				objeto[campo].codigo === '' ||
				objeto[campo].codigo === isNaN ||
				objeto[campo].codigo === 0) {
					asignarValidacionCampo(campoValidacion, false)
			} else {
				asignarValidacionCampo(campoValidacion, true)
			}
		}

		const validarTextoAdicional = (objeto, campoValidacion, campo) => {
			if (objeto === null || objeto[campo] === undefined ||
				objeto[campo] === null || objeto[campo] === '') {
					asignarValidacionCampoAdicional(campoValidacion, false)
			} else {
				asignarValidacionCampoAdicional(campoValidacion, true)
			}
		}

		const validarComboAdicional = (objeto, campoValidacion, campo) => {
			if (objeto === null || objeto[campo] === null ||
				objeto[campo] === undefined ||
				objeto[campo].codigo === null ||
				objeto[campo].codigo === -1 ||
				objeto[campo].codigo === '' ||
				objeto[campo].codigo === isNaN ||
				objeto[campo].codigo === 0) {
					asignarValidacionCampoAdicional(campoValidacion, false)
			} else {
				asignarValidacionCampoAdicional(campoValidacion, true)
			}
		}

		const asignarValidacionCampoAdicional = (campo, valor) => {
			validado = validado && valor
			setState((state) => {
				return {
					...state,
					campoValidadoAdicional: {
						...state.campoValidadoAdicional,
						[campo]: valor
					}
				}
			})
		}

		const invocarPutAseguradoAdicional = async () => {
			try {

				let idSolicitudMultiple = state.asegurado !== undefined && state.asegurado !== null ? state.asegurado.idSolicitudMultiple : null;
				
				generalDispatch(GeneralActions.setAseguradoAdicionalProspecto(
					{
						...state.aseguradoAdicional
					}
				))

				const response = await FamiliarRepository.guardarFamiliarAdicional(idSolicitudMultiple, state.aseguradoAdicional)
				if(response.error === null) {
					setState((state) => {
						return {
							...state,
							estaCargando: false,
							errorCargando: null
						}
					})
					return true
				} else {
					generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
					return false
				}

			} catch (error) {
				console.error(error)
			}
		}

		const invocarPutAsegurado = async () => {
			try {
				//DISPATCH
				generalDispatch(GeneralActions.setAseguradoProspecto(
					{
						...state.asegurado,
						indicadorModificacionDatosPID: state.asegurado.indicadorModificacionDatosPID === '2'
						? state.asegurado.indicadorModificacionDatosPID : '1'
					}
				))

				// Setear la data para enviar a firma, es el assessmentId y el resultado de coberturas del servicio de completado de reflex
				//Descomentar el siguiente bloque cuando funcione correctamente reflex
				let coberturasReflex = []
				if (state.confProducto) {
					state.suscripcionResultado.producto.map((item) =>
						item.cobertura.map((item2) => {
							coberturasReflex.push({
								codigoProducto: item.CodigoProducto,
								codigoVersionProducto: item.CodigoVersionProducto,
								codigoCobertura: parseInt(item2.CodigoCobertura),
								respuestaReflex: item2.FlagRespuesta,
							})
							return item2
						})
					)
					generalDispatch(GeneralActions.reflexDataResponseFirma(state.suscripcion.assessmentId, coberturasReflex))
				}

				return true
			} catch (error) {
				console.error(error)
			}
		}

		// Si tiene producto especial (176, 177, 178) y confProducto es true, permitir continuar sin mostrar modal
		if (state.suscripcion === null && existeAssessmetId === null && state.confProducto) {
			if (!hasSpecialProduct) {
				mostrarPopup3()
				validado = false
				return;
			}
			validado = true
		} else {
			const resultHealthDeclaration = await invocarPostAseguradoDeclaracionSalud()
			if(!resultHealthDeclaration && textWeightHeightRef.current.length){
                setModalWeightHeight(true)
				validado = false
				return;
			}
			if (resultHealthDeclaration && state.confProducto) {

				 validado = true
			}
			else {
				if (existeAssessmetId !== undefined && existeAssessmetId !== null) {
					validado = true
				} else {
					validado = false
				}
			}
			
			// Si tiene producto especial (176, 177, 178), no validar suscripcionResultado
			if (!state.suscripcionResultado && state.confProducto && !hasSpecialProduct) {
				mostrarPopup2()
				validado = false
				return;
			}
		}

		// Si tiene producto especial (176, 177, 178) y confProducto es true, permitir continuar sin mostrar modal para asegurado adicional
		if (state.esAseguradoAdicional && state.suscripcionAdicional === null && existeAssessmetIdAdicional === null && state.confProducto) {
			if (!hasSpecialProduct) {
				mostrarPopup6()
				validado = false
				return;
			}
			validado = true
		} else {
			if (state.esAseguradoAdicional && await invocarPostAseguradoAdicionalDeclaracionSalud() && state.confProducto) {
				validado = true
			} else {
				if ( state.esAseguradoAdicional && existeAssessmetIdAdicional !== undefined && existeAssessmetIdAdicional !== null) {
					validado = true
				} else if(state.esAseguradoAdicional){
					validado = false
				}
			}
			// Si tiene producto especial (176, 177, 178), no validar suscripcionResultadoAdicional
			if (state.esAseguradoAdicional && !state.suscripcionResultadoAdicional && state.confProducto && !hasSpecialProduct) {
				mostrarPopup2()
				validado = false
				return;
			}
		}


		if (!state.confProducto) {
			validado = true
		}
		
		//Invocar Servicio Post Asegurado
		//Validaciones para continuar
		if (Deshabilitar() !== true) {
			if (validado) {
				validarTexto(state.asegurado, 'nombres', 'nombres')
				validarTexto(state.asegurado, 'apellidoPaterno', 'apellidoPaterno')
				validarTexto(state.asegurado, 'apellidoMaterno', 'apellidoMaterno')
				validarCombo(state.asegurado, 'nacionalidad', 'nacionalidad')
				validarCombo(state.asegurado, 'estadoCivil', 'estadoCivil')

				if(state.esAseguradoAdicional) {
					validarTextoAdicional(state.aseguradoAdicional, 'nombres', 'nombres')
					validarTextoAdicional(state.aseguradoAdicional, 'apellidoPaterno', 'apellidoPaterno')
					validarTextoAdicional(state.aseguradoAdicional, 'apellidoMaterno', 'apellidoMaterno')
					validarComboAdicional(state.aseguradoAdicional, 'nacionalidad', 'nacionalidad')
					validarComboAdicional(state.aseguradoAdicional, 'estadoCivil', 'estadoCivil')
					if(!validado){
						mostrarPopup6()
						return
					}
				}

				//Valida si ya se ha completado el formulario y existe un AssessmentId
				if ( !state.esAseguradoAdicional && existeAssessmetId !== undefined && existeAssessmetId !== null) {
					
					if (state.suscripcionResultado.producto) {
						invocarPutAsegurado()
					} else {
						generalDispatch(GeneralActions.setAseguradoProspecto(
							{
								...state.asegurado,
								indicadorModificacionDatosPID: state.asegurado.indicadorModificacionDatosPID === '2'
								? state.asegurado.indicadorModificacionDatosPID : '1'
							}
						))
					}
					return validado
				} else if(state.esAseguradoAdicional && existeAssessmetId !== undefined && existeAssessmetId !== null && existeAssessmetIdAdicional !== undefined && existeAssessmetIdAdicional !== null) {
					
					if (state.suscripcionResultado.producto && state.suscripcionResultadoAdicional.producto) {
						invocarPutAsegurado()
						invocarPutAseguradoAdicional()
					} else {
						generalDispatch(GeneralActions.setAseguradoProspecto(
							{
								...state.asegurado,
								indicadorModificacionDatosPID: state.asegurado.indicadorModificacionDatosPID === '2'
								? state.asegurado.indicadorModificacionDatosPID : '1'
							}
						))
						generalDispatch(GeneralActions.setAseguradoAdicionalProspecto(
							{...state.aseguradoAdicional}
						))
					}
					return validado
				} else {
					if (validado) {
						invocarPutAsegurado()
						if(state.esAseguradoAdicional){
							invocarPutAseguradoAdicional()
						}
					} 
					return validado
				}

			} else {
				validarTexto(state.asegurado, 'nombres', 'nombres')
				validarTexto(state.asegurado, 'apellidoPaterno', 'apellidoPaterno')
				validarTexto(state.asegurado, 'apellidoMaterno', 'apellidoMaterno')
				validarCombo(state.asegurado, 'nacionalidad', 'nacionalidad')
				validarCombo(state.asegurado, 'estadoCivil', 'estadoCivil')

				if(state.esAseguradoAdicional) {
					validarTextoAdicional(state.aseguradoAdicional, 'nombres', 'nombres')
					validarTextoAdicional(state.aseguradoAdicional, 'apellidoPaterno', 'apellidoPaterno')
					validarTextoAdicional(state.aseguradoAdicional, 'apellidoMaterno', 'apellidoMaterno')
					validarComboAdicional(state.aseguradoAdicional, 'nacionalidad', 'nacionalidad')
					validarComboAdicional(state.aseguradoAdicional, 'estadoCivil', 'estadoCivil')
				}

				return validado
			}
		} else {
			if(state.esAseguradoAdicional) {
				return invocarPutAsegurado() && invocarPutAseguradoAdicional()
			} else {
				return invocarPutAsegurado()
			}
		}
	}

	//Modo lectura
	let Deshabilitar = (complete) => {
		complete = cotizacion.edicionInhabilitada
		if (complete === true && complete !== undefined) {
			return true
		} else {
			return false
		}
	}
	let existeAssessmetId = state !== undefined && state !== null ? state.assessmentIdSolicitudes : null;
	let existeAssessmetIdAdicional = state !== undefined && state !== null ? state.assessmentIdSolicitudesAdicional : null;

	const [mover, setMover] = useState(false)
	const mueveContenido = (valor) => {
		setMover(valor)
	}

	const onChangeInputDate = (valor) => {
		handleChangeFecha(valor, 'fechaNacimiento')
	}

	const deleteScriptQuestionnaire = () =>{
		const head = document.querySelector("head");
		if (head) {
		  const allScripts = head.querySelectorAll("script") ?? [];
		  const allCss = head.querySelectorAll("[type='text/css']");
		  const lastCss = allCss[allCss.length - 1];
  
		  if (allCss && lastCss && !lastCss.disabled) lastCss.disabled = true;
  
		  allScripts.forEach((script) => {
			if (script?.id === "polyfills" || script?.id === "questionnaire")
			  head?.removeChild(script);
		  });
		}
	  }

const changeTab = (numberTab) => {

	if((isQuestionnairePrincipalComplete() && !state.isOpenQuestionnaireSubscription && numberTab == insureAditionalTab) || 
	(isQuestionnaireAditionalComplete() && !state.isOpenQuestionnaireSubscriptionAditional && numberTab == insuredPrincipalTab)){
		setTap(numberTab);
	}else{
		setMostrarModalCuestionario(true);
	}
}

const isQuestionnairePrincipalComplete = () => state.cuestionarioValidado || (existeAssessmetId !== null && existeAssessmetId !== undefined);
const isQuestionnaireAditionalComplete = () => state.cuestionarioValidadoAdicional  || (existeAssessmetIdAdicional !== null && existeAssessmetIdAdicional !== undefined);

const finishQuestionnairePrincipalAnswers = () =>{
	setAnswersPrincipalComplete(true);
}

const finishQuestionnaireAditionalAnswers = () =>{
	setanswersAditionalComplete(true);
}

const showModalMessageQuestionnaire = (message) =>{
	return (<Modal
		mostrarModal={mostrarModalCuestionario}
		setModal={setMostrarModalCuestionario}
		doble={false}
		textos={message}
		accion={() => setMostrarModalCuestionario(false)}
	/>)
}

return (
		<React.Fragment>
			<Header history={history} />
			<SubMenu history={history} modal={mostrarModal2 || mostrarModal3 || mostrarModal4 || mostrarModal || state.estaCargando || state.estaCargandoFamily} desplaza={mueveContenido}/>
			<section className={styles['areadatosusuario']} style={mover ? { width: '93%', paddingLeft: '6.5%', height: '100vh' } : {}} >
				<div className={styles['areadatosprospecto']}>

					{
						state.esAseguradoAdicional ?
							<div>
								<div className={styles['tabsSeleccionarAsegurado']}>
									<div className={ tap === 1 ? styles['tabsSeleccionarAseguradoSelec'] : null}>
										<a onClick={() => changeTab(insuredPrincipalTab) }>Asegurado Principal</a>
									</div>
									<div className={ tap === 2 ? styles['tabsSeleccionarAseguradoSelec'] : null}>
										<a onClick={() => changeTab(insureAditionalTab)} >Asegurado Adicional</a>
									</div>
								</div>	
								<br/><br/>
							</div>
						: null
					}
					
					
					

					{
						tap === 1 ?
							<div className='tap1'>
								<Subtitle sname='Declaración de Salud y Ocupación' smostrar='false'/>
								<p className={styles['areadatosprospecto__subtitulo_info']}>
									Ayúdanos a validar tus datos.
								</p>
								<div className={`${styles['grupodeform']} ${styles['top18']}`}>
									<div className={styles['area50']}>
										<label>Nombres&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<input
											type='input'
											className={!state.campoValidado.nombres ? styles['logerror'] : null}
											style={{ paddingLeft: '2%' }}
											value={state.asegurado !== null ? Funciones.mostrarCamelCase(state.asegurado.nombres) : ''}
											ref={nombresRef}
											maxLength='40'
											onChange={(e) => handleChangeTexto(e, 'nombres')}
											disabled={Deshabilitar() !== true ? false : true}
										/>
										{!state.campoValidado.nombres && (
											<span className={styles['span-error']}>
											{Constantes.MENSAJE_VALIDACION_NOMBRES}
											</span>
										)}
									</div>
									<div className={styles['area25']}>
										<label>Apellido Paterno&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<input
											type='input'
											className={
												!state.campoValidado.apellidoPaterno ? styles['logerror'] : null
											}
											value={state.asegurado !== null ? Funciones.mostrarCamelCase(state.asegurado.apellidoPaterno) : ''}
											ref={apePaternoRef}
											maxLength='40'
											onChange={(e) => handleChangeTexto(e, 'apellidoPaterno')}
											disabled={Deshabilitar() !== true ? false : true}
										/>
										{!state.campoValidado.apellidoPaterno && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_APE_PATERNO}
											</span>
										)}
									</div>
									<div className={styles['area25']}>
										<label>Apellido Materno{(state.asegurado && state.asegurado.tipoDocumento.codigo) !== 3 ? Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : ''}</label>
										<input
											type='input'
											className={
												(!state.campoValidado.apellidoMaterno && (state.asegurado && state.asegurado.tipoDocumento.codigo) !== 3) ? styles['logerror'] : null
											}
											value={state.asegurado !== null ? Funciones.mostrarCamelCase(state.asegurado.apellidoMaterno) : ''}
											ref={apeMaternoRef}
											maxLength='40'
											onChange={(e) => handleChangeTexto(e, 'apellidoMaterno')}
											disabled={Deshabilitar() !== true ? false : true}
										/>
										{!state.campoValidado.apellidoMaterno && (
											<span className={styles['span-error']}>
												{(state.asegurado && state.asegurado.tipoDocumento.codigo) !== 3 ? Constantes.MENSAJE_VALIDACION_APE_MATERNO : ''}
											</span>
										)}
									</div>
								</div>

								<div className={`${styles['contenedor4']}`}>
									<div className={styles['box']}>
										<label>Tipo Doc.&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<select
											className={ !state.campoValidado.tipoDocumento ? `${styles['logerror']} ${styles['tipoDoc']}` : styles['tipoDoc'] }
											value={  state.asegurado !== null ? state.asegurado.tipoDocumento.codigo : '' }
											onChange={handleChangeTipDocumento}
											disabled
										>
											<option value=''>Seleccione</option>
											{documentos.map((documento) => (
												<option key={documento.id} value={documento.id}>
													{documento.valor}
												</option>
											))}
										</select>
										{!state.campoValidado.tipoDocumento && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_TIP_DOCUMENTO}
											</span>
										)}
									</div>
									<div className={styles['box2']}>
										<label>Nro. de Doc. Identidad&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<input
											type='input'
											className={
												!state.campoValidado.numeroDocumento ? styles['logerror'] : null
											}
											value={state.asegurado !== null ? state.asegurado.numeroDocumento : ''}
											ref={nroDocRef}
											maxLength='40'
											onChange={(e) => handleChangeNumerico(e, 'numeroDocumento')}
											disabled
										/>
										{!state.campoValidado.numeroDocumento && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_NUM_DOCUMENTO}
											</span>
										)}
									</div>
									<div className={styles['box3']}>
										<CampoFecha
											name={'Fecha Nacimiento'}
											esObligatorio={true}
											valor={state.asegurado !== null && state.asegurado.fechaNacimiento !== undefined && state.asegurado.fechaNacimiento !== null
												? Funciones.transformarFechaToDatePicker(state.asegurado.fechaNacimiento) : ''}
											disabled={state.asegurado !== null &&
												state.asegurado.fechaNacimiento &&
												state.asegurado.fechaNacimiento !== Constantes.CADENA_VACIA &&
												state.bloqueaFecha
											}
											onChange={(valor) => onChangeInputDate(valor)}
										/>
									</div>
									<div className={styles['box4']}>
										<label>Sexo&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<div className={styles['centered']}>
											<label className={styles['label-radio']}>
												<input type='radio' name='sexo' value={0}
													selected={
														state.asegurado !== null && state.asegurado.sexo.codigo === 0
													}
													checked={
														state.asegurado === null || state.asegurado.sexo.codigo === 0
													}
													onChange={handleChangeSexo}
													disabled
												/>
												<span className="span-radio-sexo">Femenino</span>
											</label>
											<label className={styles['label-radio']}>
												<input type='radio' name='sexo' value={1}
													selected={
														state.asegurado !== null && state.asegurado.sexo.codigo === 1
													}
													checked={
														state.asegurado !== null && state.asegurado.sexo.codigo === 1
													}
													onChange={handleChangeSexo}
													disabled
												/>
												<span className="span-radio-sexo">Masculino</span>
											</label>
										</div>
									</div>
								</div>

								<div className={`${styles['grupodeform']} ${styles['top18']}`}>
									<div className={styles['area25']}>
										<label>Nacionalidad&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<select
											className={ !state.campoValidado.nacionalidad ? `${styles['logerror']} ${styles['tipoDoc']}` : styles['tipoDoc']}
											value={state.asegurado !== null ? state.asegurado.nacionalidad.codigo : ''}
											onChange={handleChangeNacionalidad}
											disabled={Deshabilitar() !== true ? false : true}
										>
											<option value=''>Seleccione nacionalidad</option>
											{nacionalidades.map((nacionalidad) => (
												<option key={nacionalidad.id} value={nacionalidad.id}>
													{nacionalidad.valor}
												</option>
											))}
										</select>
										{!state.campoValidado.nacionalidad && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_NACIONALIDAD}
											</span>
										)}
									</div>
									<div className={styles['area25']}>
										<label>Estado Civil&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<select
											className={!state.campoValidado.estadoCivil ? `${styles['logerror']} ${styles['estadoCivil']}`: styles['estadoCivil']}
											value={state.asegurado !== null && state.asegurado.estadoCivil !== null && state.asegurado.estadoCivil.codigo !== null
												? state.asegurado.estadoCivil.codigo : -1}
											onChange={handleChangeEstadoCivil}
											disabled={Deshabilitar() !== true ? false : true}
										>
											<option value={''}>Seleccione</option>
											{estados !== undefined
												? estados.map((estado) => (
												<option key={estado.id} value={estado.id}>
													{estado.valor}
												</option>
											))
											: null}
										</select>
										{!state.campoValidado.estadoCivil && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_EST_CIVIL}
											</span>
										)}
									</div>
									{/**[INI]-VALIDACION PARA MOSTRAR EL BOTON DE INICIAR DS */}
									{ocultaBoton ?
											<div className={`${styles['area50']} ${styles['area-boton']}`} />
										:
											<div className={`${styles['area50']} ${styles['area-boton']}`}>
												<button
													type='button'
													style={{ width: '20%' }}
													className={Deshabilitar() !== true ? state.cuestionarioValidado ? styles['btn-no-accion'] : styles['button-right-inside'] : styles['button-right-inside-inhabilitar']}
													disabled={Deshabilitar() !== true ? false : true}
													onClick={state.cuestionarioValidado ? null : existeAssessmetId === undefined || existeAssessmetId === null ? mostrarSuscripcion : mostrarPopup4}>
													Iniciar DS
												</button>
											</div>
									}
									{/**[FIN]-VALIDACION PARA MOSTRAR EL BOTON DE INICIAR DS */}
								</div>
					
					
								{/**[INI]-Se agrega Formulario reflex embebido */}
								{state.suscripcion ?
								<Suspense fallback={<CargandoPagina />}>
									<QuestionnaireLazy insuredQuestionnaire={state.suscripcion} finishQuestionnaireAnswers={finishQuestionnairePrincipalAnswers}/>
								</Suspense> : null
								}
								{state.suscripcion ?
									<div className={`${styles['area50']} ${styles['area-boton']}`} style={{ marginTop: '1%', marginLeft: '41%' }}>
										<button type='button' className={styles['button-right-inside']} onClick={terminoSD}>
											Finalizar DS
										</button>
									</div>
									: null
								}
								{/**[FIN]-Se agrega Formulario reflex embebido */}
								{state.cuestionarioValidado || (existeAssessmetId !== null && existeAssessmetId !== undefined)
									? 
										<div className={styles['confirmacion']}>
											<div className={styles['round']}>
												<input type="checkbox" id="checkbox" defaultChecked={true} />
												<label htmlFor="checkbox"></label>
											</div>
											<label className={styles['label-confirmacion']}>Cuestionario completado correctamente</label>
										</div>
									: null
								}
							</div>
						:
							<div className='tap2'>
								<Subtitle sname='Declaración de Salud y Ocupación - Asegurado Adicional' smostrar='false'/>
								<p className={styles['areadatosprospecto__subtitulo_info']}>
									Ayúdanos a validar tus datos.
								</p>
								<div className={`${styles['grupodeform']} ${styles['top18']}`}>
									<div className={styles['area50']}>
										<label>Nombres&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<input
											type='input'
											className={!state.campoValidadoAdicional.nombres ? styles['logerror'] : null}
											style={{ paddingLeft: '2%' }}
											value={state.aseguradoAdicional !== null ? Funciones.mostrarCamelCase(state.aseguradoAdicional.nombres) : ''}
											maxLength='40'
											onChange={(e) => handleChangeTextoAdicional(e, 'nombres')}
											disabled={Deshabilitar() !== true ? false : true}
										/>
										{!state.campoValidadoAdicional.nombres && (
											<span className={styles['span-error']}>
											{Constantes.MENSAJE_VALIDACION_NOMBRES}
											</span>
										)}
									</div>
									<div className={styles['area25']}>
										<label>Apellido Paterno&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<input
											type='input'
											className={!state.campoValidadoAdicional.apellidoPaterno ? styles['logerror'] : null}
											value={state.aseguradoAdicional !== null ? Funciones.mostrarCamelCase(state.aseguradoAdicional.apellidoPaterno) : ''}
											maxLength='40'
											onChange={(e) => handleChangeTextoAdicional(e, 'apellidoPaterno')}
											disabled={Deshabilitar() !== true ? false : true}
										/>
										{!state.campoValidadoAdicional.apellidoPaterno && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_APE_PATERNO}
											</span>
										)}
									</div>
									<div className={styles['area25']}>
									<label>Apellido Materno{(state.aseguradoAdicional && state.aseguradoAdicional.tipoDocumento.codigo) !== 3 ? Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : ''}</label>
										<input
											type='input'
											className={(!state.campoValidadoAdicional.apellidoMaterno && (state.aseguradoAdicional && state.aseguradoAdicional.tipoDocumento.codigo) !== 3) ? styles['logerror'] : null}
											value={state.aseguradoAdicional !== null ? Funciones.mostrarCamelCase(state.aseguradoAdicional.apellidoMaterno) : ''}
											maxLength='40'
											onChange={(e) => handleChangeTextoAdicional(e, 'apellidoMaterno')}
											disabled={Deshabilitar() !== true ? false : true}
										/>
										{!state.campoValidadoAdicional.apellidoMaterno && (
											<span className={styles['span-error']}>
												{(state.aseguradoAdicional && state.aseguradoAdicional.tipoDocumento.codigo) !== 3 ? Constantes.MENSAJE_VALIDACION_APE_MATERNO : ''}
											</span>
										)}
									</div>
								</div>
								<div className={`${styles['contenedor4']}`}>
									<div className={styles['box']}>
										<label>Tipo Doc.&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<select
											className={ !state.campoValidadoAdicional.tipoDocumento ? `${styles['logerror']} ${styles['tipoDoc']}` : styles['tipoDoc'] }
											value={  state.aseguradoAdicional !== null ? state.aseguradoAdicional.tipoDocumento.codigo : '' }
											onChange={handleChangeTipDocumentoAdicional}
											disabled
										>
											<option value=''>Seleccione</option>
											{documentos.map((documento) => (
												<option key={documento.id} value={documento.id}>
													{documento.valor}
												</option>
											))}
										</select>
										{!state.campoValidadoAdicional.tipoDocumento && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_TIP_DOCUMENTO}
											</span>
										)}
									</div>
									<div className={styles['box2']}>
										<label>Nro. de Doc. Identidad&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<input
											type='input'
											className={!state.campoValidadoAdicional.numeroDocumento ? styles['logerror'] : null}
											value={state.aseguradoAdicional !== null ? state.aseguradoAdicional.numeroDocumento : ''}
											maxLength='40'
											onChange={(e) => handleChangeNumericoAdicional(e, 'numeroDocumento')}
											disabled
										/>
										{!state.campoValidadoAdicional.numeroDocumento && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_NUM_DOCUMENTO}
											</span>
										)}
									</div>
									<div className={styles['box3']}>
										<CampoFecha
											name={'Fecha Nacimiento'}
											esObligatorio={true}
											valor={state.aseguradoAdicional !== null && state.aseguradoAdicional.fechaNacimiento !== undefined && state.aseguradoAdicional.fechaNacimiento !== null
												? Funciones.transformarFechaToDatePicker(state.aseguradoAdicional.fechaNacimiento) : ''}
												disabled={state.aseguradoAdicional !== null &&
													state.aseguradoAdicional.fechaNacimiento &&
													state.aseguradoAdicional.fechaNacimiento !== Constantes.CADENA_VACIA &&
													state.bloqueaFecha
												}
											onChange={(valor) => handleChangeFechaAdicional(valor, 'fechaNacimiento')}
										/>
									</div>
									<div className={styles['box4']}>
										<label>Sexo&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<div className={styles['centered']}>
											<label className={styles['label-radio']}>
												<input type='radio' name='sexo' value={0}
													selected={
														state.aseguradoAdicional !== null && state.aseguradoAdicional.sexo.codigo === 0
													}
													checked={
														state.aseguradoAdicional === null || state.aseguradoAdicional.sexo.codigo === 0
													}
													onChange={handleChangeSexoAdicional}
													disabled
												/>
												<span className="span-radio-sexo">Femenino</span>
											</label>
											<label className={styles['label-radio']}>
												<input type='radio' name='sexo' value={1}
													selected={
														state.aseguradoAdicional !== null && state.aseguradoAdicional.sexo.codigo === 1
													}
													checked={
														state.aseguradoAdicional !== null && state.aseguradoAdicional.sexo.codigo === 1
													}
													onChange={handleChangeSexoAdicional}
													disabled
												/>
												<span className="span-radio-sexo">Masculino</span>
											</label>
										</div>
									</div>
								</div>
								<div className={`${styles['grupodeform']} ${styles['top18']}`}>
									<div className={styles['area25']}>
										<label>Nacionalidad&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<select
											className={ !state.campoValidadoAdicional.nacionalidad ? `${styles['logerror']} ${styles['tipoDoc']}` : styles['tipoDoc']}
											value={state.aseguradoAdicional !== null && state.aseguradoAdicional.nacionalidad !== null && state.aseguradoAdicional.nacionalidad.codigo !== null 
												? state.aseguradoAdicional.nacionalidad.codigo : -1}
											onChange={handleChangeNacionalidadAdicional}
											disabled={Deshabilitar() !== true ? false : true}
										>
											<option value=''>Seleccione nacionalidad</option>
											{nacionalidades.map((nacionalidad) => (
												<option key={nacionalidad.id} value={nacionalidad.id}>
													{nacionalidad.valor}
												</option>
											))}
										</select>
										{!state.campoValidadoAdicional.nacionalidad && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_NACIONALIDAD}
											</span>
										)}
									</div>
									<div className={styles['area25']}>
										<label>Estado Civil&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
										<select
											className={!state.campoValidadoAdicional.estadoCivil ? `${styles['logerror']} ${styles['estadoCivil']}`: styles['estadoCivil']}
											value={state.aseguradoAdicional !== null && state.aseguradoAdicional.estadoCivil !== null && state.aseguradoAdicional.estadoCivil.codigo !== null
												? state.aseguradoAdicional.estadoCivil.codigo : -1}
											onChange={handleChangeEstadoCivilAdicional}
											disabled={Deshabilitar() !== true ? false : true}
										>
											<option value={''}>Seleccione</option>
											{estados !== undefined
												? estados.map((estado) => (
												<option key={estado.id} value={estado.id}>
													{estado.valor}
												</option>
											))
											: null}
										</select>
										{!state.campoValidadoAdicional.estadoCivil && (
											<span className={styles['span-error']}>
												{Constantes.MENSAJE_VALIDACION_EST_CIVIL}
											</span>
										)}
									</div>
									{
										ocultaAdicionalBoton?
											<div className={`${styles['area50']} ${styles['area-boton']}`} />
										:
											<div className={`${styles['area50']} ${styles['area-boton']}`}>
												<button
													type='button'
													style={{ width: '20%' }}
													className={Deshabilitar() !== true ? state.cuestionarioValidadoAdicional ? styles['btn-no-accion'] : styles['button-right-inside'] : styles['button-right-inside-inhabilitar']}
													disabled={Deshabilitar() !== true ? false : true}
													onClick={state.cuestionarioValidadoAdicional ? null : existeAssessmetIdAdicional === undefined || existeAssessmetIdAdicional === null ? mostrarSuscripcionAdicional : mostrarPopup4Adicional}>
													Iniciar DS
												</button>
											</div>
									}
								</div>
								{state.suscripcionAdicional?
								<Suspense fallback={<CargandoPagina />}>
								<QuestionnaireLazy insuredQuestionnaire={state.suscripcionAdicional} finishQuestionnaireAnswers={finishQuestionnaireAditionalAnswers}/>
							</Suspense>
									
									: null
								}
								{state.suscripcionAdicional ?
									<div className={`${styles['area50']} ${styles['area-boton']}`} style={{ marginTop: '1%', marginLeft: '41%' }}>
										<button type='button' className={styles['button-right-inside']} onClick={terminoSDAdicional}>
											Finalizar DS
										</button>
									</div>
									: null
								}
								{ state.cuestionarioValidadoAdicional  || (existeAssessmetIdAdicional !== null && existeAssessmetIdAdicional !== undefined)
									? 
										<div className={styles['confirmacion']}>
											<div className={styles['round']}>
												<input type="checkbox" id="checkbox" defaultChecked={true} />
												<label htmlFor="checkbox"></label>
											</div>
											<label className={styles['label-confirmacion']}>Cuestionario completado correctamente</label>
										</div>
									: null
								}
							</div>
					}


				</div>
				<Modal mostrarModal={Deshabilitar() !== true ? mostrarModal : null} setModal={setModal} textos={textos} />  {/**Se agrega popup para validación del boton Finalizar DS */}
				<Modal mostrarModal={Deshabilitar() !== true ? mostrarModal2 : null} setModal={setModal2} textos={textos2} />
				<Modal mostrarModal={Deshabilitar() !== true ? mostrarModal3 : null} setModal={setModal3} textos={textos3} />
				<Modal mostrarModal={Deshabilitar() !== true ? mostrarModal6 : null} setModal={setModal6} textos={textos6} />
				<Modal
					mostrarModal={mostrarModal4}
					setModal={setModal4}
					doble={true}
					textos={textos4}
					accion={() => mostrarSuscripcion()}
				/>
				{showModalMessageQuestionnaire(["Declaración Salud","Debes finalizar el cuestionario"])}
				<Modal
					mostrarModal={mostrarModal4Adicional}
					setModal={setModal4Adicional}
					doble={true}
					textos={textos4}
					accion={() => mostrarSuscripcionAdicional()}
				/>
				<Modal mostrarModal={mostralModal5} setModal={setModal5} textos={textos5} />
				<Modal mostrarModal={modalWeightHeight} setModal={setModalWeightHeight} textos={textWeightHeightRef.current} />
				<Footer history={history} validarPantalla={validarFormulario} />
			</section>
		</React.Fragment>
	)
}

export default DeclaracionSalud